import React from 'react'
import NeedsSignIn from './components/NeedsSignIn'
import { Domain, Functions } from './core'
import { View } from 'react-native'
import Routes from './Routes'
import { Dispatch } from 'redux'
import { useDispatch } from 'react-redux'
import { Api } from './lib'
import { setTenant, clearTenant } from './core/modules/tenant'

const needsToLineLogin = Functions.LineLogin.checkNeedToLineLogin()

export default function InitialSetup () {
  const [signInFinished, setSignInFinished] = React.useState(false)
  const [signInFailed, setSignInFailed] = React.useState(false)
  function changeFavicon (link: string) {
    const element = window.document.getElementById('favicon') as HTMLLinkElement
    element.href = link
  }

  const dispatch = useDispatch()

  const fetchTenantDetail = React.useCallback(() => {
    function didFetchTenantDetail (data: Domain.Tenant.Entity, reduxDispatch: Dispatch) {
      changeFavicon(data.favicon)
      document.title = data.tenantName
      reduxDispatch(clearTenant())
      reduxDispatch(setTenant(data))
    }
    const reloader = () => {
      dispatch(fetchTenantDetail())
    }
    return function(reduxDispatch: Dispatch) {
      Api.callApi(Api.HttpMethod.get, `tenants/${process.env.REACT_APP_TENANT_ID}`, '', null, didFetchTenantDetail, reduxDispatch, {
        reload: reloader,
      }, '', true)
    }
  }, [dispatch])

  React.useEffect(() => {
    setTimeout(() => {
      Domain.Auth.init().then((value: boolean) => {
        dispatch(fetchTenantDetail())
        if (value && needsToLineLogin) {
          const isRedirectAfterLogin = window.location.pathname === encodeURI('/Menu/券売機チャージ_D') || window.location.pathname === encodeURI('/Menu/券売機チャージ_R')
          Domain.Auth.signIn({redirectUri: isRedirectAfterLogin ? window.location.href : undefined})
            .then(() => {
              setSignInFailed(false)
            })
            .catch(() => {
              setSignInFailed(true)
            })
            .finally(() => {
              setSignInFinished(true)
            })
        }
      })
    }, 500);
  }, [dispatch, fetchTenantDetail])

  if (needsToLineLogin && !signInFinished) {
    return <View />
  } else if (needsToLineLogin && signInFailed) {
    return <NeedsSignIn />
  }
  return (
    <>
      <Routes />
    </>
  )
}
